import { MetricField } from "@/components/dashboard/metrics-games/common";
import { confidenceBand, confidenceMultiplier } from "@/components/dashboard/metrics-games/utils";

type Props = {
  sampleSize: number;
  onSetSampleSize: (value: number) => void;
};

export function GameConfidence({ sampleSize, onSetSampleSize }: Props) {
  const confidenceMultiplierValue = confidenceMultiplier(sampleSize);
  const confidenceBandValue = confidenceBand(confidenceMultiplierValue);

  return (
    <article className="card metrics-game">
      <div className="metrics-game-head">
        <p className="section-label">Game 2</p>
        <h2 className="card-title">Confidence multiplier</h2>
      </div>
      <p className="card-desc">
        Move sample size and watch the confidence penalty and confidence band update.
      </p>

      <div className="metrics-slider-row">
        <label className="form-label" htmlFor="sample-size-slider">
          Startup sample size: {sampleSize}
        </label>
        <div style={{ "--slider-fill": `${((sampleSize - 1) / 29) * 100}%` } as React.CSSProperties}>
          <input
            id="sample-size-slider"
            type="range"
            min={1}
            max={30}
            value={sampleSize}
            className="metrics-slider"
            onChange={(event) => onSetSampleSize(Number(event.target.value))}
          />
        </div>
      </div>

      <div className="score-breakdown-grid">
        <MetricField label="Confidence multiplier" value={confidenceMultiplierValue.toFixed(2)} />
        <MetricField label="Confidence band" value={confidenceBandValue} />
        <MetricField label="Rule" value="<5: 0.65 | 5-9: 0.80 | 10-14: 0.90 | 15+: 1.00" />
        <MetricField
          label="Impact"
          value={`${Math.round((1 - confidenceMultiplierValue) * 100)}% score penalty`}
        />
      </div>
    </article>
  );
}
